import TextForm from "../components/TextForm.tsx";
import {useTranslation} from "react-i18next";
import {useContext, useState} from "react";
import {Container, Paper} from "@mui/material";
import AuthContext from "../contexts/AuthContext.tsx";
import Typography from "@mui/material/Typography";
import {SupportedLanguages} from "../models/Languages.ts";
import i18n from "i18next";

const RegisterPage = () => {
    const {t} = useTranslation()
    const formLabels = [`${t('EMAIL_TEXT')}`, `${t('PASSWORD_TEXT')}`, `${t('PASSWORD_CONFIRMATION_TEXT')}`]
    const [formData, setFormData] = useState<any>({
        email: {value: '', required: true},
        password: {value: '', required: true},
        password_confirmation: {value: '', required: true},
    })
    const {registerMutation, registerError, setRegisterError} = useContext(AuthContext)
    const currentLanguage: SupportedLanguages = i18n.language as SupportedLanguages;
    const [loading, setLoading] = useState<boolean>(false);


    const handleChange = (key: string, value: string) => {
        const updatedValue = formData[key]
        updatedValue.value = value
        setFormData((prevValue: any) => ({
            ...prevValue,
            [key]: updatedValue
        }))
    }

    return (
        <Container sx={{padding: '12px'}}>
            <Paper elevation={4}
                   sx={{
                       display: 'flex',
                       flexDirection: 'column',
                       alignItems: 'center',
                       maxWidth: '900px',
                       margin: 'auto',
                       padding: '12px',
                   }}
            >
                <TextForm
                    formLabels={formLabels}
                    formData={formData}
                    loading={loading}
                    submitText={`${t('REGISTER_TEXT')}`}
                    onChange={handleChange}
                    onSubmit={() => {
                        setLoading(true)
                        setRegisterError(null)

                        if (formData.password.value !== formData.password_confirmation.value) {
                            setRegisterError(t("PASSWORDS_NOT_MATCHING"))
                            setLoading(false)
                            return
                        }
                        registerMutation.mutate(
                            {
                                email: formData.email.value,
                                password: formData.password.value,
                                language: currentLanguage,
                            },
                            {
                                onSuccess: () => {
                                    setLoading(false)
                                },
                                onError: () => {
                                    setLoading(false)
                                }
                            }
                        )
                    }}

                    formHeader={`${t('REGISTER_TEXT')}`}
                />
                {registerError ? (
                    <Typography
                        sx={{color: 'red'}} variant="body1"
                    >
                        {registerError}
                    </Typography>
                ) : null}
            </Paper>
        </Container>
    )
}

export default RegisterPage;